/* tslint:disable */
/* eslint-disable */
/* Code generated by ng-openapi-gen DO NOT EDIT. */

import { HttpClient, HttpContext, HttpResponse } from '@angular/common/http';
import { Observable } from 'rxjs';
import { filter, map } from 'rxjs/operators';
import { StrictHttpResponse } from '../../strict-http-response';
import { RequestBuilder } from '../../request-builder';

import { WidgetList } from '../../models/widget-list';

export interface GetWidgetConfigDetails$Params {
  orid?: number;
}

export function getWidgetConfigDetails(http: HttpClient, rootUrl: string, params?: GetWidgetConfigDetails$Params, context?: HttpContext): Observable<StrictHttpResponse<Array<WidgetList>>> {
  const rb = new RequestBuilder(rootUrl, getWidgetConfigDetails.PATH, 'get');
  if (params) {
    rb.query('orid', params.orid, {});
  }

  return http.request(
    rb.build({ responseType: 'json', accept: 'application/json', context })
  ).pipe(
    filter((r: any): r is HttpResponse<any> => r instanceof HttpResponse),
    map((r: HttpResponse<any>) => {
      return r as StrictHttpResponse<Array<WidgetList>>;
    })
  );
}

getWidgetConfigDetails.PATH = '/api/DashboardManagement/getWidgetConfig';
